const DONE = 'Done'

export default status => status === DONE